module.exports = __webpack_public_path__ + "img/620de19.png";